import InstallAppPromptIOS from "./InstallAppPromptIOS";

export default InstallAppPromptIOS;
